import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminShop, errMsg } from "../../lib/shopApi";
import { Field, btn, inputCls } from "./shared";

export const ShopSettingsTab = ({ passcode, status, reload }) => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { setEmail(status?.alert_email || ""); }, [status]);
  const siteUrl = process.env.REACT_APP_BACKEND_URL;

  const saveEmail = async () => {
    try { await adminShop.saveSettings({ alert_email: email }, passcode); toast("Saved."); reload(); }
    catch (e) { toast.error(errMsg(e)); }
  };

  const connect = async () => {
    setBusy(true);
    try { await adminShop.connectWebhook(siteUrl, passcode); toast("Printful will now send shipping updates here."); reload(); }
    catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="space-y-8 max-w-2xl" data-testid="admin-shop-settings">
      <div>
        <Field label="Where should order alerts go?" hint="New Printed Mint orders, Printful problems and held orders are emailed here.">
          <div className="flex gap-2">
            <input type="email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-shop-alert-email" />
            <button type="button" className={btn.primary} onClick={saveEmail} data-testid="admin-shop-alert-email-save">Save</button>
          </div>
        </Field>
      </div>
      <div>
        <p className="font-display text-xl text-[#4B3A2F]">Printful shipping updates</p>
        <p className="text-sm text-[#6D5A50] mb-3">
          Lets Printful tell this site when orders ship, so customers get tracking emails automatically. Printful allows one site at a time —
          {status?.printful_webhook_url ? ` currently connected to ${status.printful_webhook_url}.` : " not connected yet."}
        </p>
        <button type="button" className={btn.ghost} onClick={connect} disabled={busy || !status?.printful_connected} data-testid="admin-shop-connect-webhook">
          {busy ? "Connecting…" : "Connect updates to this site"}
        </button>
        {status?.printful_error && <p className="text-sm text-[#A3302A] mt-2" data-testid="admin-shop-printful-error">{status.printful_error}</p>}
      </div>
      <div className="text-sm text-[#6D5A50] space-y-1">
        <p><b>Payments:</b> {status?.stripe_test_mode ? "Test mode — no real charges." : "Live."}</p>
        <p><b>Printful orders:</b> {status?.live_fulfillment ? "Sent for printing automatically after payment." : "Saved as drafts in Printful (never printed or charged) while testing."}</p>
        <p><b>Customer emails:</b> {status?.email_enabled ? "On (receipt, shipped + tracking)." : "Off — email service not configured."}</p>
      </div>
    </div>
  );
};
